import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatIcon} from "@angular/material/icon";
import {MatButton, MatIconButton} from "@angular/material/button";
import {TranslatePipe} from "@ngx-translate/core";
import {Collection} from "../../collection.model";
import {CollectionShareLinkComponent} from "./collection-share-link/collection-share-link.component";
import {CollectionShareAccessComponent} from "./collection-share-access/collection-share-access.component";
import {
    CollectionSharePublicationComponent
} from "./collection-share-publication/collection-share-publication.component";

@Component({
    selector: 'app-collection-share',
    imports: [
        MatDialogContent,
        MatIcon,
        MatIconButton,
        TranslatePipe,
        MatButton,
        CollectionShareLinkComponent,
        CollectionShareAccessComponent,
        CollectionSharePublicationComponent
    ],
    templateUrl: './collection-share.component.html',
    styleUrl: './collection-share.component.scss'
})
export class CollectionShareComponent {

    collection: Collection;
    error: string | null = null;

    state: 'init' | 'access' | 'link' | 'publication' = 'init';

    constructor(
        private dialogRef: MatDialogRef<CollectionShareComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Collection,
    ) {
        this.collection = data;
    }

    handleCollectionChange(collection: Collection) {
        this.collection = collection;
        this.close();
    }

    close() {
        this.dialogRef.close(this.collection);
    }

}
